import { useEffect, useState } from 'react';

const subscribe = (mql, onChange) => {
  if (mql.addEventListener) {
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }
  // Safari < 14
  mql.addListener(onChange);
  return () => mql.removeListener(onChange);
};

/**
 * True while the CSS media query matches. Re-renders on change (rotation,
 * window resize), unlike a bare `window.innerWidth` read during render.
 * Returns false in environments without matchMedia (tests, SSR).
 */
export default function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    return subscribe(mql, onChange);
  }, [query]);

  return matches;
}

/** Phone breakpoint used by the mobile layout pass: anything below Tailwind `md`. */
export const PHONE_QUERY = '(max-width: 767.98px)';
export const useIsPhone = () => useMediaQuery(PHONE_QUERY);
